import Financing from '@/app/components/Financing'
import Head from 'next/head'

export default function FinancingPage() {
  return (
    <>
      <Head>
        <title>Azul Agro - Financiamento</title>
        <meta name="description" content="Descubra as opções de financiamento da Azul Agro. Estamos prontos para ajudar você a otimizar suas operações agrícolas com nossas soluções de alta performance." />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/desktop/financing/introSection.webp"} media="(min-width: 1140px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/tablet/financing/introSection.webp"} media="(min-width: 540px) and (max-width: 1139px)" />
        <link rel="preload" as="image" href={"https://gabcomercio.azureedge.net/azul-agro/mobile/financing/introSection.webp"} media="(max-width: 539px)" />
      </Head>
      <Financing />
    </>
  )
}
